const DEPLOYED_PROFILES = new Set(['production', 'demo']);

function resolveApiUrl(environment = process.env) {
  const profile = (environment.REACT_APP_DEPLOYMENT_PROFILE || '').trim().toLowerCase();
  // A local bundle must never inherit a deployed API destination from its
  // invoking shell or build environment.
  if (profile === 'local') return 'http://localhost:5001/api';
  const configured = (environment.REACT_APP_API_URL || '').trim();
  if (configured) return configured;
  if (DEPLOYED_PROFILES.has(profile)) {
    const error = new Error('FRONTEND_API_ORIGIN_REQUIRED');
    error.code = 'FRONTEND_API_ORIGIN_REQUIRED';
    throw error;
  }
  return 'http://localhost:5001/api';
}

module.exports = { resolveApiUrl };
